import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "@/components/app/shell/page-header";
import { ReadFailed } from "@/components/app/lists/read-failed";
import { Skeleton } from "@/components/ui/skeleton";
import { orpc } from "@/lib/orpc";
import { guardRoute } from "@/lib/policy/route-guard";
import { NativeRoles } from "@/routes/_authenticated/_administration/settings/roles/-components/native-roles";

export const Route = createFileRoute("/_authenticated/platform_/roles/")({
  beforeLoad: ({ context }) => guardRoute(context.me, "platform-console"),
  component: NativeRolesConsole,
});

/** The native roles, kept here and only here: every organization has them. */
function NativeRolesConsole() {
  const list = useQuery(orpc.administration.roles.native.list.queryOptions({}));

  return (
    <div className="space-y-8">
      <PageHeader
        title="Native roles"
        meta="The ready-made roles every organization starts with. Organizations give them or copy them; only this page changes them."
      />
      {list.isPending ? (
        <Skeleton className="h-96 w-full" />
      ) : list.isError ? (
        <ReadFailed
          message="The native roles could not be loaded."
          error={list.error}
          retrying={list.isFetching}
          onRetry={() => void list.refetch()}
        />
      ) : (
        <NativeRoles
          place="console"
          roles={list.data.map((role) => ({ ...role, assignedCount: role.people }))}
        />
      )}
    </div>
  );
}
